export const LOG_LOCATION = 'applinks.administration';
export const APPLINKS_V3_QUERY_URL =
	'/rest/applinks/3.0/applinks?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems';
export const APPLINKS_LIST_PAGE_URL = '/plugins/servlet/applinks/listApplicationLinks';
